import { EventSourceMessage, fetchEventSource } from '@microsoft/fetch-event-source'

// export const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_HOST || 'http://0.0.0.0:8005'
export const BACKEND_BASE_URL = 'https://api.smartscrape.ai'

export const fetchAnalyseTweetsSummaryMessage = async (
    // session: string,
    messages: {
        role: string
        content: string
        date_filter: string
        response_order: string
    }[],
    // model: string,
    onopen: (res: Response) => void,
    onmessage: (event: EventSourceMessage) => void,
    onerror: (err: any) => void,
    onclose: () => void,
    signal: AbortSignal,
) => {
    await fetchEventSource(`${BACKEND_BASE_URL}/analyse-tweets-event`, {
        openWhenHidden: true,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
            access_key: 'hello',
        },
        body: JSON.stringify({ messages }),

        async onopen(res) {
            onopen(res)
        },
        onmessage(event: any) {
            onmessage(event)
        },
        onclose() {
            onclose()
        },
        onerror(err: any) {
            onerror(err)
        },
        signal,
    })
}
